import e from"../../metadata.min.json.js";import o from"../../es6/AsYouType.js";function t(r){return o.call(this,r,e)}t.prototype=Object.create(o.prototype,{});t.prototype.constructor=t;export{t as AsYouType};
